export default {
  en: {
    title: 'Audit Logs',
    subtitle: 'List of operations performed by your users.',
    changes: 'Change details',
    noChanges: 'This operation did not record any changes.',
    original: 'Before',
    result: 'After',
    removed: 'removed field',
    filters: {
      user: 'Filter by user email',
      endpoint: 'Filter by endpoint',
      operation: 'Operation',
      rangeTooLongTitle: 'Date range too wide',
      rangeTooLong: 'You can only query up to one month of logs.',
    },
    operations: {
      create: 'Create',
      patch: 'Update',
      remove: 'Delete',
    },
    columns: {
      id: 'ID',
      user: 'User',
      operation: 'Operation',
      endpoint: 'Endpoint',
      ipAddress: 'IP Address',
      userAgent: 'User Agent',
    },
  },
  es: {
    title: 'Registros de auditoría',
    subtitle: 'Lista de operaciones realizadas por tus usuarios.',
    changes: 'Detalle de cambios',
    noChanges: 'Esta operación no registró cambios.',
    original: 'Antes',
    result: 'Después',
    removed: 'campo eliminado',
    filters: {
      user: 'Filtrar por email',
      endpoint: 'Filtrar por endpoint',
      operation: 'Operación',
      rangeTooLongTitle: 'Rango de fechas muy amplio',
      rangeTooLong: 'Solo puedes consultar hasta un mes de registros.',
    },
    operations: {
      create: 'Creación',
      patch: 'Actualización',
      remove: 'Eliminación',
    },
    columns: {
      id: 'ID',
      user: 'Usuario',
      operation: 'Operación',
      endpoint: 'Endpoint',
      ipAddress: 'Dirección IP',
      userAgent: 'Agente de usuario',
    },
  },
  fr: {
    title: 'Journaux d\'audit',
    subtitle: 'Liste des opérations effectuées par vos utilisateurs.',
    changes: 'Détail des modifications',
    noChanges: 'Cette opération n\'a enregistré aucune modification.',
    original: 'Avant',
    result: 'Après',
    removed: 'champ supprimé',
    filters: {
      user: 'Filtrer par e-mail',
      endpoint: 'Filtrer par point de terminaison',
      operation: 'Opération',
      rangeTooLongTitle: 'Plage de dates trop large',
      rangeTooLong: 'Vous ne pouvez consulter qu\'un mois de journaux au maximum.',
    },
    operations: {
      create: 'Création',
      patch: 'Mise à jour',
      remove: 'Suppression',
    },
    columns: {
      id: 'ID',
      user: 'Utilisateur',
      operation: 'Opération',
      endpoint: 'Point de terminaison',
      ipAddress: 'Adresse IP',
      userAgent: 'Agent utilisateur',
    }
  }
}
